"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../../../schema");
const igG = schema_1.Schema.number()
    .expiration(15552000)
    .unit("g/L")
    .precision(2)
    .min(0)
    .max(50)
    .interpretation({ vocab: "ltx", code: "immun_elfo_igg" })
    .tag({ vocab: "snomed", code: "69480007" })
    .tag({ vocab: "loinc", code: "2324-2" });
const igA = schema_1.Schema.number()
    .optional()
    .expiration(15552000)
    .unit("g/L")
    .precision(2)
    .min(0)
    .max(20)
    .interpretation({ vocab: "ltx", code: "immun_elfo_iga" })
    .tag({ vocab: "snomed", code: "69480007" })
    .tag({ vocab: "loinc", code: "2324-2" });
const igM = schema_1.Schema.number()
    .optional()
    .expiration(15552000)
    .unit("g/L")
    .precision(2)
    .min(0)
    .max(20)
    .interpretation({ vocab: "ltx", code: "immun_elfo_igm" })
    .tag({ vocab: "snomed", code: "69480007" })
    .tag({ vocab: "loinc", code: "2324-2" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ IgG: igG, IgA: igA, IgM: igM })
    .interpretation({ vocab: "ltx", code: "immun_elfo" })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "396550006" })
    .tag({ vocab: "snomed", code: "26958001" })
    .tag({ vocab: "loinc", code: "24325-3" });
